import React, { FC } from 'react'
import { LoadingBar, Box } from '@components/gassan-ui'
import { motion } from 'framer-motion'
import { Parent } from './CartRow/elements'

const LoadingRow: FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
    >
      <Parent>
        <LoadingBar
          width="100%"
          height={{ _: '3.75rem', small: '10.5rem', large: '6rem', xlarge: '11rem' }}
        />
        <Box>
          <LoadingBar
            width={{ _: '100%', small: '11rem', xlarge: '16.5rem' }}
            height={{ _: '1.5rem', small: '2.5rem', xlarge: '2.25rem' }}
            mb="0.5rem"
          />
          <LoadingBar
            width={{ _: '80%', small: '8.5rem', xlarge: '12.5rem' }}
            height={{ _: '1.5rem', small: '2.5rem', xlarge: '2.25rem' }}
            mb="0.5rem"
          />
          <LoadingBar
            display={{ _: 'none', xlarge: 'flex' }}
            width={{ _: '100%', small: '8.5rem', xlarge: '12.5rem' }}
            height={{ _: '2.5rem', xlarge: '2.25rem' }}
            mb="0.5rem"
          />
        </Box>
        <LoadingBar
          display={['none', 'flex']}
          width={{ _: '6rem', xlarge: '100%' }}
          height={{ _: '2.5rem', xlarge: '2.25rem' }}
        />
        <LoadingBar
          display={{ _: 'none', xlarge: 'flex' }}
          width={{ _: '6rem', xlarge: '100%' }}
          height={{ _: '2.5rem', xlarge: '2.25rem' }}
        />
        <LoadingBar
          display={{ _: 'none', xlarge: 'flex' }}
          width={{ _: '6rem', xlarge: '100%' }}
          height={{ _: '2.5rem', xlarge: '2.25rem' }}
        />
      </Parent>
    </motion.div>
  )
}

export default LoadingRow
